import { render, staticRenderFns } from "./PrevKPIitem.vue?vue&type=template&id=7e37127c&"
import script from "./PrevKPIitem.vue?vue&type=script&lang=js&"
export * from "./PrevKPIitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports